import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    MemoryRouter,
    Link,
    Redirect
    // useHistory
} from "react-router-dom";
import axios from 'axios';
import Loading from '../Loading/Loading';
import './Settings.css';



class Settings extends Component {

    constructor(props) {
        super(props);

        let clientInfo = JSON.parse(localStorage.getItem('clientInfo'));

        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo.accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

        this.state = {
            title: 'Configurações',
            items: {
                portability: false,
                privacy: false,
                terms: false
            },
            settings: {
                sms: false,
                phone: false,
                call: false,
            }

        }

    }

    componentDidMount() {

        // console.log('COMPONENT_DID_MOUNT');
        // console.log({
        //     settings: {
        //         sms: this.getCookie('sms') === "true",
        //         phone: this.getCookie('phone') === "true",
        //         call: this.getCookie('call') === "true",
        //     }
        // });


        this.setState({
            settings: {
                sms: this.getCookie('sms') === "true",
                phone: this.getCookie('phone') === "true",
                call: this.getCookie('call') === "true",
            }
        })
    }

    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + "; " + expires;
    }

    setSettings(setting, value) {


        this.setCookie(setting, value, 365)
        this.setState({
            settings: {
                ...this.state.settings,
                [setting]: value
            }
        })
    }

    backToSettings(element) {
        element.preventDefault();

        this.setState({
            title: 'Configurações',
            items: {
                portability: false,
                privacy: false,
                terms: false
            }
        })
    }

    displayOptions(option) {

        if (option === 'portability') return false;

        let title = '';
        switch (option) {
            case 'portability':
                title = 'Portabilidade'
                break;
            case 'privacy':
                title = 'Privacidade'
                break;
            case 'terms':
                title = 'Termos de uso'
                break;
        }


        this.setState({

            title: title,
            items: {
                ...this.state.items,
                [option]: true
            }
        })


    }


    render() {

        return (
            <div className="settings">
                <div className="container">
                    <div className="card">


                        {

                            (this.state.items.portability === true
                                || this.state.items.privacy === true
                                || this.state.items.terms === true) &&

                            <div className="card-body">
                                <div className="btn-back back-recarga-btn"><a onClick={(element) => { this.backToSettings(element) }} href="#"> Voltar </a></div>
                            </div>
                        }

                        <div className="card-header">
                            <h1>{this.state.title}</h1>
                        </div>

                        <div className="card-body">

                            {

                                (this.state.items.portability === false
                                    && this.state.items.privacy === false
                                    && this.state.items.terms === false) &&
                                <div>
                                    <ul className="settings-options">
                                        <li>
                                            <Link to="portabilidade">
                                                <div className="img-option">
                                                    <img src={require('../../icons/portability.svg')} />
                                                </div>
                                                <div>
                                                    <h4>Portabilidade</h4>
                                                    <p>Traga seu número</p>
                                                </div>
                                                <div className="arrow-icon" href="#" ></div>
                                            </Link>
                                        </li>

                                        {/* <li onClick={() => {this.displayOptions('privacy')}}>
                                            <div className="img-option">
                                                <img src={require('../../icons/privacy.svg')} />
                                            </div>
                                            <div>
                                                <h4>Privacidade</h4>
                                                <p>Consumo, SMS, Telefone</p>
                                            </div>
                                            <div className="arrow-icon" href="#" ></div>
                                        </li> */}

                                        <li onClick={() => { this.displayOptions('terms') }}>
                                            <div className="img-option">
                                                <img src={require('../../icons/terms.svg')} />
                                            </div>
                                            <div>
                                                <h4>Termos de uso</h4>
                                                <p>Termos de serviço e priva...</p>
                                            </div>
                                            <div className="arrow-icon" href="#" ></div>
                                        </li>
                                    </ul>
                                    {/*  <div className="btn-sair">
                                        <a href="/home" className="btn btn-outline-default">Sair</a>
                                    </div> */}
                                </div>
                            }
                            {

                                (this.state.items.portability === true
                                    || this.state.items.privacy === true
                                    || this.state.items.terms === true) &&

                                <div className="container-options">

                                    {
                                        this.state.items.portability === true &&
                                        <div className="display-portability">Portabilidade</div>
                                    }


                                    {
                                        this.state.items.privacy === true &&
                                        <div className="display-privacy">

                                            <ul className="privaty-container">
                                                <li>
                                                    <p>Ocultar SMS no consumo</p>

                                                    {/* {
                                                        console.log('this.state.settings.sms', this.state.settings.phone)
                                                    } */}
                                                    <div>
                                                        <label className="switch">
                                                            <input type="checkbox" checked={this.state.settings.sms} onChange={() => { this.setSettings('sms', !this.state.settings.sms) }} />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                </li>

                                                <li>
                                                    <p>Ocultar Ligações no consumo</p>
                                                    <div>
                                                        <label className="switch">
                                                            <input type="checkbox" checked={this.state.settings.call} onChange={() => { this.setSettings('call', !this.state.settings.call) }} />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                </li>
                                            </ul>



                                        </div>
                                    }


                                    {
                                        this.state.items.terms === true &&
                                        <div className="display-terms">
                                            <div>
                                                O presente aceite e termos de condições de uso se aplica exclusivamente ao Site Correios Recarga e tem prazo de vigência indeterminado.
                                                <br />
                                                <br />
                                                Para fins de utilização do Site Correios Recarga, considera-se “Usuário” qualquer pessoa física, cliente do Correios Recarga ou não, que interaja com o sistema.
                                                <br />
                                                <br />
                                                O usuário, ao utilizar o Site Correios Recarga, concorda e aceita, expressamente e sem reservas ou ressalvas, todas as condições aqui dispostas, assim como as disposições do Contrato de Adesão do Correios Recarga. Ao utilizar o Site Correios Recarga, o usuário reconhece e aceita a coleta, utilização e divulgação de informações de identificação pessoal para fins descritos no presente termos de uso.
                                                <br />
                                                <br />
                                                O usuário autoriza expressamente o Correios Recarga a comunicar-se com o mesmo para o envio de mensagens com teor informativo sobre o status de determinado serviço prestado.
                                                <br />
                                                <br />
                                                O Correios Recarga se compromete a proteger a privacidade dos dados dos usuários do Site Correios Recarga não realizando intercâmbio de dados pessoais com terceiros para fins promocionais. O Correios Recarga não irá fornecer informações pessoais a terceiros sem a sua permissão, exceto quando para responder às suas solicitações ou consultas, ou se o Correios Recarga entender que a divulgação das informações é necessária para responder a reclamações e ações judiciais de que o conteúdo que você submeteu infringe os direitos de terceiros ou é necessária para proteger direitos, propriedades ou segurança do Correios Recarga, dos usuários do Site Correios Recarga e/ou do público em geral.
                                                <br />
                                                <br />
                                                O Site Correios Recarga coletam informações de localização e endereço de internet, bem como outras informações essencialmente técnicas, tais como versão do sistema operacional e versão utilizada.
                                                <br />
                                                <br />
                                                O Correios Recarga reserva-se o direito de adotar medidas de prevenção ao uso indevido e/ou fraudulento, podendo ser caracterizadas novas hipóteses de tais utilizações. Além disso, ao utilizar o Site Correios Recarga o usuário autoriza a comunicação dos meus dados pessoais e informações de cartão de crédito a terceiros contratados pelo Correios Recarga para garantir a segurança da operação e prevenção de fraude.
                                                <br />
                                                <br />
                                                O Correios Recarga fica isento de qualquer responsabilidade na hipótese de indisponibilidade dos serviços por motivos de força maior e caso fortuito, bem como daqueles decorrentes de manutenção e/ou problemas nos sistemas e equipamentos utilizados para a execução da prestação dos serviços. Todo e qualquer problema apresentado pelo Site Correios Recarga deve ser notificado à Central de Relacionamento do Correios Recarga, através dos canais de atendimento disponíveis.
                                                <br />
                                                <br />
                                                O Correios Recarga poderá realizar alterações nestes Termos e Condições de Uso a qualquer momento sem necessariamente comunicar antecipadamente o usuário.
                                            </div>

                                        </div>
                                    }

                                </div>

                            }

                        </div>

                    </div>
                </div>
                <Loading loading={this.state.loading} />
            </div>
        );
    }

}

export default Settings